module.exports = __webpack_public_path__ + "static/img/indicator_light06.cf746e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/indicator_light06.png
// module id = +QXq
// module chunks = 1